<template>
  <div>
    <div id="loading-wrapper" ref="loadingWrapper">
      <div class="spinner">
        <div class="line1"></div>
        <div class="line2"></div>
        <div class="line3"></div>
        <div class="line4"></div>
        <div class="line5"></div>
        <div class="line6"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <card>
          <div slot="header">
            <h4 class="title">Reporte de tiraje</h4>
          </div>
          <div>
            <form>
              <div class="row">
                <!--div class="col-md-4 form-group has-label mb-0">
                  <label>Libro</label>
                  <el-select class="select-primary"
                            size="large"
                            placeholder="Libro"
                            v-model="report.book">
                    <el-option v-for="option in this.report.booksList"
                                :value="option.value"
                                :label="option.label"
                                :key="option.label">
                    </el-option>
                  </el-select>
                </div-->
                <div class="col-md-4 form-group has-label">
                  <label>Tiraje</label>
                  <el-select
                    class="select-primary"
                    size="large"
                    placeholder="Tiraje"
                    v-model="report.run"
                  >
                    <el-option
                      v-for="option in this.report.runsList"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="col-md-4 form-group has-label">&nbsp;</div>
              </div>

              <div>
                <button
                  type="submit"
                  class="btn btn-primary btn-fill btn-wd"
                  @click.prevent="generateReport"
                >
                  <i class="fa fa-file"></i> &nbsp;Generar reporte
                </button>
              </div>
              <div class="clearfix"></div>
            </form>
          </div>
        </card>
      </div>
    </div>

    <div class="row" v-if="run.date">
      <div class="col-sm-12">
        <card>
          <div slot="header">
            <h4 class="title mt-0 mb-0">Detalle de tiraje</h4>
          </div>
          <div>
            <div class="row">
              <div class="col-md-4">
                <fg-input type="text" label="Fecha" placeholder="Fecha" v-model="run.date" readonly>
                </fg-input>
              </div>
              <div class="col-md-4">
                <fg-input type="text" label="Cantidad" placeholder="Cantidad" v-model="run.quantity" readonly>
                </fg-input>
              </div>
              <div class="col-md-4">
                <fg-input type="text" label="Costo ($)" placeholder="Costo" v-model="run.cost" readonly>
                </fg-input>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="row" v-if="salesData && salesData.length > 0">
      <div class="col-sm-12">
        <card>
          <div slot="header">
            <h4 class="title mt-0 mb-0">Vendidos a la fecha</h4>
          </div>
          <div class="row">
            <div class="col-md-8">
              <el-table :data="salesData">
                <el-table-column type="index" width="80" align="right"></el-table-column>
                <el-table-column prop="date" label="Fecha"></el-table-column>
                <el-table-column prop="quantity" label="Cantidad" align="right"></el-table-column>
                <el-table-column prop="pos" label="Punto de venta"></el-table-column>
                <el-table-column prop="price" label="Precio de venta" align="right" :formatter="(row) => `$${row.price.toFixed(2)}`"></el-table-column>
                <el-table-column prop="profit" label="Ganancia" align="right" :formatter="(row) => `$${row.profit.toFixed(2)}`"></el-table-column>
              </el-table>
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="row" v-if="profit.total">
      <div class="col-sm-12">
        <card>
          <div slot="header">
            <h4 class="title mt-0 mb-0">Ganancia total</h4>
          </div>
          <div>
            <div class="row">
              <div class="col-md-4">
                <fg-input type="text" label="Ganancia a la fecha ($)" placeholder="Ganancia" v-model="profit.total" readonly>
                </fg-input>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="row" v-if="remainingBooks && remainingBooks.length > 0">
      <div class="col-sm-12">
        <card>
          <div slot="header">
            <h4 class="title mt-0 mb-0">Remanente de libros</h4>
          </div>
          <div class="row">
            <div class="col-md-6">
              <el-table :data="remainingBooks">
                <el-table-column type="index" width="80"></el-table-column>
                <el-table-column prop="pos" label="Punto de venta"></el-table-column>
                <el-table-column prop="quantity" label="Cantidad" align="right"></el-table-column>
              </el-table>
            </div>
          </div>

        </card>
      </div>
    </div>

  </div>
</template>

<script>
import { Input, Tag, Select, Option } from "element-ui";
import { Table, TableColumn } from "element-ui";
import axios from "axios";

export default {
  components: {
    [Input.name]: Input,
    [Tag.name]: Tag,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      salesData: [],
      remainingBooks: [],
      report: {
        booksList: [],
        runsList: [],
        book: "",
        run: "",
      },
      run: {
        date: "",
        quantity: 0,
        cost: 0,
      },
      profit: {
        total: null,
      },
      user: JSON.parse(localStorage.getItem('user')),
    };
  },
  mounted() {
    this.fetchDataFromAPI();
  },
  methods: {
    generateReport() {
      let wrapper = this.$refs.loadingWrapper;
      wrapper.style.display = "block";

      // runs list
      axios
        .get(
          this.$systemVariables.apiUrl +
            "runs/" + this.report.run +
            "?rand=" +
            Math.random().toString(),
          {
            headers: { Authorization: JSON.parse(localStorage.getItem("jwt")).value },
          }
        )
        .then((response) => {
          this.run.date = response.data.message.run_date;
          this.run.quantity = response.data.message.run_quantity;
          this.run.cost = response.data.message.run_cost;

          // sales and profit
          axios
            .get(
              this.$systemVariables.apiUrl +
                "author/sales?run=" + this.report.run +
                "&rand=" +
                Math.random().toString(),
              {
                headers: { Authorization: JSON.parse(localStorage.getItem("jwt")).value },
              }
            )
            .then((response) => {
              this.salesData = response.data.message;

              let totalProfit = 0;
              this.salesData.forEach((item) => {
                totalProfit += item.profit;
              });
              this.profit.total = totalProfit.toFixed(2);

              // remaining books
              axios
                .get(
                  this.$systemVariables.apiUrl +
                    "author/remaining?run=" + this.report.run +
                    "&rand=" +
                    Math.random().toString(),
                  {
                    headers: { Authorization: JSON.parse(localStorage.getItem("jwt")).value },
                  }
                )
                .then((response) => {
                  this.remainingBooks = response.data.message;

                  wrapper.style.display = "none";
                });

              wrapper.style.display = "none";
            });
        });
    },
    async fetchDataFromAPI() {
      let wrapper = this.$refs.loadingWrapper;
      wrapper.style.display = "block";

      /*axios
        .get(
          this.$systemVariables.apiUrl +
            "author/books?perPage=500&rand=" +
            Math.random().toString() +
            "&uuid=" +
            this.user.uuid,
          {
            headers: { Authorization: JSON.parse(localStorage.getItem("jwt")).value },
          }
        )
        .then((response) => {
          this.report.booksList = response.data.message;
        });*/
      axios
        .get(
          this.$systemVariables.apiUrl +
            "author/runs?perPage=500&forSelect=1&rand=" +
            Math.random().toString() +
            "&uuid=" +
            this.user.uuid,
          {
            headers: { Authorization: JSON.parse(localStorage.getItem("jwt")).value },
          }
        )
        .then((response) => {
          this.report.runsList = response.data.message;
        });

      wrapper.style.display = "none";
    },
  },
};
</script>
<style>
.el-input__inner {
  cursor: pointer !important;
}
.el-table .warning-row {
  background: oldlace;
}
</style>
